import { useAppSelector } from 'src/utils/Hooks';
import { useDeepCompareMemo } from 'src/utils/app';
import _pick from 'lodash/pick';
import ReduxStore from 'src/types/store/reduxStore';

/**
 * @deprecated use useTimePeriods from 'src/utils/Hooks/reduxSelectors'
 * Get a subset of main time period and comparison time periods
 * with the properties that are required for SRG
 */
const useTimePeriods = () => {
  const mainTimePeriod = useAppSelector((state) => state.mainTimePeriod);
  const comparisonTimePeriod = useAppSelector((state) => state.comparisonTimePeriod);

  const mainTimePeriodMemo = useDeepCompareMemo(
    () => _pick(mainTimePeriod, ['endDayId', 'endWeek', 'startDayId', 'startWeek', 'displayName']),
    [mainTimePeriod]
  ) as Pick<ReduxStore['mainTimePeriod'], 'endDayId' | 'endWeek' | 'startDayId' | 'startWeek' | 'displayName'>;

  const comparisonTimePeriodMemo = useDeepCompareMemo(
    () => _pick(comparisonTimePeriod, ['endDayId', 'endWeek', 'startDayId', 'startWeek', 'displayName']),
    [comparisonTimePeriod]
  ) as Pick<ReduxStore['mainTimePeriod'], 'endDayId' | 'endWeek' | 'startDayId' | 'startWeek' | 'displayName'>;

  return {
    mainTimePeriod: mainTimePeriodMemo,
    comparisonTimePeriod: comparisonTimePeriodMemo
  };
};

export default useTimePeriods;
